module.exports = __webpack_public_path__ + "img/rule-black.5eeda3f7.svg";